import React from 'react';
interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
  as?: 'h2' | 'h3';
}
export function SectionTitle({
  children,
  className = '',
  as = 'h2'
}: SectionTitleProps) {
  const Tag = as;
  return <Tag className={`font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl ${className}`} data-id="element-294" data-mp="rl5nwoz03k71">
      {children}
    </Tag>;
}
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="text-brand" data-id="element-295" data-mp="dm5z9hbhn5av">{children}</span>;
}